import React from "react";
import { graphql, StaticQuery } from "gatsby";
import Prose from "../utility/prose";
import axios from 'axios'

class BuildingRentalForm extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            name: '',
            email: '',
            message: '',
            disabled: false,
            files: '',
            fileKey: '',
            fileSize: true,
            fileCountExceeded: false,
            uploadProgress: false,
            fileUploadResponse: null,
            agreement: false,
            captcha: undefined,
            recaptchaInstance: undefined,
            formError: [],
            formSuccess: '',
        }

        this.fileRef = React.createRef()
    }

    componentDidMount() {
        if (this.state.recaptchaInstance) {
            this.state.recaptchaInstance.reset();
        }
    }

    submit = (event) => {
        event.preventDefault()
        this.setState({ formSuccess: '', formError: [] }, this.handleFormEntry)

    }

    handleFormEntry = () => {

        if (this.state.disabled === false) {
            // console.log(this.props.title)

            if (this.state.name === '' ||
                this.state.email === '' ||
                this.state.files === ''
            ) {
                this.setState({ formError: this.state.formError.concat(["Form not filled out completely."]) })
            } else {
                this.setState({ disabled: true })

                let formData = new FormData()
                formData.set('name', this.state.name)
                formData.set('email', this.state.email)
                formData.set('message', this.state.message)
                formData.set('address', '')
                // formData.set('website', this.props.title)
                formData.set('website', 'Bridgestone MUD - Building Rental')
                //formData.set('website', 'TEST')
                formData.set('response', this.state.captcha)

                if (this.state.fileCountExceeded === true) { return; }
                for (let i = 0; i < this.state.files.length; i++) {

                    if (this.state.files[i].size > 2097152) {
                        this.setState({ fileSize: false });
                        this.setState({ fileUploadProgress: false });
                        this.setState({ fileUploadResponse: null });
                        return;
                    }

                    formData.append(`files[]`, this.state.files[i])
                }

                axios.post('https://backend.touchstonedistrictservices.com/v2mailer', formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            'Accept': 'application/json',
                        }
                    }).then(function(response) {
                        // console.log('Response');
                        // console.log(response.data);
                        if (response.data.status === "success") {
                            this.clearForm()
                            this.setState({ formSuccess: "Your message has been sent." })
                        } else {
                            this.setState({ formError: this.state.formError.concat(["Something went wrong, check your entry and try again."]) })
                        }

                    }.bind(this)).catch(function(error) {
                        console.log(error.response)
                    })

                if (this.state.recaptchaInstance) {
                    this.state.recaptchaInstance.reset();
                }

            }
        }

    }

    clearForm = () => {
        this.setState({ name: '', email: '', address: '', message: '', files: '', fileKey: Date.now(), disabled: false })

    }

    changeName = (event) => {
        this.setState({ name: event.target.value })
    }
    changeAddress = (event) => {
        this.setState({ address: event.target.value })
    }
    changeAgreement = (event) => {
        this.setState({ agreement: event.target.checked })
    }
    changeEmail = (event) => {
        this.setState({ email: event.target.value })
    }
    changeMessage = (event) => {
        this.setState({ message: event.target.value })
    }
    captchaVerify = (response) => {
        this.setState({ captcha: response })
    }
    onLoadRecaptcha = () => {
        if (this.state.recaptchaInstance) {
            this.state.recaptchaInstance.reset();
        }
    }

    changeFiles = (event) => {
        this.setState({ files: event.target.files })
        console.log(event.target.files.length)
        if (event.target.files.length > 2) {
            this.setState({ fileCountExceeded: true });
        } else {
            this.setState({ fileCountExceeded: false });
        }
    };



    render() {
        return (
            <Prose>
                <div className="w-full md:w-5/6 lg:w-2/3 mx-auto">
                    <h2>Building Rental Form</h2>
                    <p>To apply for building rental, please follow these steps:</p>
                    <p><ol>
                      <li>Download the Bridgestone MUD Building Rental Application by clicking on the link below.<br /><a className="primary-button mt-2" href="https://website-media-bridgestone-mud.s3.us-east-1.amazonaws.com/Application_for_Bridgestone_Municipal_Utility_District_Rental_2025_01_31_e598feb765.pdf" target="_blank" rel="noopener noreferrer">Bridgestone MUD Building Rental Application</a></li>
                      <li>Complete the application in its entirety and save it to your device.</li>
                      <li>Upload your completed application through the submission form below.</li>
                    </ol></p>
                    <p className=""></p>

                    <form name="contact" onSubmit={this.submit}>
                        {this.state.formError.length !== 0 ? (<ul className="list-none text-red-500 dark:text-red-400 border-red-400 dark:border-red-400 border-2 rounded-3xl">{this.state.formError.map((error) => (
                            <li className="" key={error} >{error}</li>
                        ))}</ul>) : < ></ >}
                        {this.state.formSuccess === '' ? (< ></ >) : (<ul className="list-none text-green-500 border-green-500 dark:text-green-400 dark:border-green-400 border-2 rounded-3xl"><li>{this.state.formSuccess}</li></ul>)}

                        <div className="mb-2">
                            <label htmlFor="name" className="text-sm uppercase pl-6">Name <span className="text-red-500 dark:text-red-400 font-bold">*</span></label>
                            <input className="block w-full rounded-full bg-neutral-200 dark:bg-neutral-800 border-0 pl-6" type="text" name="name" placeholder="Enter your name" onChange={this.changeName} value={this.state.name} />
                        </div>
                        <div className="mb-2">
                            <label htmlFor="email" className="text-sm uppercase pl-6">Email <span className="text-red-500 dark:text-red-400 font-bold">*</span></label>
                            <div className="control">
                                <input className="block w-full rounded-full bg-neutral-200 dark:bg-neutral-800 border-0 pl-6" type="email" name="email" placeholder="Enter your email" onChange={this.changeEmail} value={this.state.email} />
                            </div>
                        </div>
                        <div className="mb-4">
                            <label htmlFor="message" className="text-sm uppercase pl-6">Additional Comments</label>
                            <div className="control">
                                <textarea className="block w-full h-36 rounded-3xl bg-neutral-200 dark:bg-neutral-800 border-0 pl-6" name="message" placeholder="Enter any comments" onChange={this.changeMessage} value={this.state.message}></textarea>
                            </div>
                        </div>
                        <div className="mb-4">
                            <label htmlFor="files[]" className="text-sm uppercase pl-6">Please upload the completed Rental Application Form <span className="text-red-500 dark:text-red-400 font-bold">*</span></label>

                            <div className="control">
                                <input className="text-sm file:px-4 file:py-2 file:uppercase file:border-0 file:bg-neutral-200 hover:file:bg-neutral-300 dark:file:bg-neutral-800 hover:dark:file:bg-neutral-900 file:text-inherit file:rounded-full" ref={this.fileRef} type="file" name="files[]" multiple accept="application/pdf,image/*" onChange={this.changeFiles} key={this.state.fileKey || ''}></input>
                                {!this.state.fileSize && <p className="text-sm text-red-500 dark:text-red-400">File size exceeded!!</p>}
                                {this.state.fileCountExceeded && <p className="text-sm text-red-500 dark:text-red-400">Too Many Files</p>}
                                {this.state.fileUploadProgress && <p className="text-sm text-red-500 dark:text-red-400">Uploading File(s)</p>}
                                {this.state.fileUploadResponse != null && <p className="text-sm text-green-500 dark:text-green-400">{this.state.fileUploadResponse}</p>}
                            </div>
                        </div>
                        <div className="">
                            <div className="control">
                                <input className="inline-block text-base uppercase bg-green-300 hover:bg-green-400 dark:bg-green-700 hover:dark:bg-green-800 mr-1 mb-2 px-4 py-2 rounded-full leading-none" type="submit" name="submit" value="Submit" />
                            </div>
                        </div>
                    </form>
                </div>
            </Prose>
        )
    }
}

export default () => (
    <StaticQuery query={graphql`
        query {
            site {
                siteMetadata {
                    title
                }
            }
        }
    `}
        render={(data) => (
            <BuildingRentalForm title={data.site.siteMetadata.title} />
        )}
    />
)

